import { ReactNode } from "react";
import style from "./big-modal-container.module.css";
import Modal from "../modal/modal";
import AppLogo from "../ui-components/logo";

export default function BigModalContainer({
  source,
  withPortal = true,
  children,
}: {
  source: string;
  withPortal?: boolean;
  children: ReactNode;
}) {
  return (
    <Modal dimBackground withPortal={withPortal}>
      <div className={style.container}>
        <div className={style.logo}>
          <AppLogo source={source} />
        </div>
        <div className={style.content}>{children}</div>
      </div>
    </Modal>
  );
}
